// extracted by mini-css-extract-plugin
export default {"starRating":"rBnJj8","starIcon":"j0A7Ss","starIconActive":"hbITua","size-30":"HEhRgk"};